<template>
<ValidationObserver class="div" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CCard>
            <CCardBody>
                <CRow>
                    <CCustomInput
                        sm="12"
                        vid="name"
                        :name="$t('campaign.name')+' '+$t('campaign._')"
                        rules="required"
                        required
                        v-model="campaign.name"
                    />

                    <CCustomTextarea
                        sm="12"
                        vid="description"
                        :name="$t('campaign.description')+' '+$t('campaign._')"
                        v-model="campaign.description"
                        placeholder="در صورتی که مورد خاصی وجود دارد که باید توسط ما در نظر گرفته شود در این جا ذکر کنید."
                    />

                    <CCustomSearchableInput
                        v-if="!campaign.id && !$policy('campaign').create_own"
                        col="12"
                        vid="store_id"
                        :name="$t('store._')"
                        v-model="storeId"
                        required
                        rules="required"
                        :items="selectableStores"
                    />

                    <CCol col="12" class="text-left mt-3">
                        <CButton type="submit" :disabled="invalid" color="primary">{{ campaign.id ? $t('submit') : $t('btn.next_step') }}</CButton>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'CampaignInfoForm',

    props: {
        campaign: {
            default() {
                return {
                    name: '',
                    description: '',
                    store_id: null
                }
            },
            type: Object
        }
    },

    data() {
        return {
            localStoreId: null,
        }
    },

    computed: {
        ...mapGetters({
            selectableStores: 'store/selectableStores'
        }),
        storeId: {
            get() {
                return this.localStoreId
            },
            set(val) {
                this.localStoreId = val.value
            }
        }
    },

    methods: {
        submit() {
            this.$emit('submit', {
                name: this.campaign.name,
                description: this.campaign.description,
                store_id: this.localStoreId.value ? this.localStoreId.value : this.localStoreId,
            })
        }
    },

    mounted() {
        if (this.campaign.store_id && this.selectableStores) {
            const selectable = this.selectableStores.find(selectable => selectable.value == this.campaign.store_id)
            this.localStoreId = selectable ? selectable : ''
        }
    }
}
</script>